import { render, staticRenderFns } from "./Casa.vue?vue&type=template&id=7634421e"
import script from "./Casa.vue?vue&type=script&lang=js"
export * from "./Casa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports